<template>
  <div
    v-if="hasGallery"
    class="product-gallery-slot"
  >
    <product-gallery
      :title="TITLE"
      :products="PRODUCTS"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ProductGallery from '@/components/product-gallery/product-gallery.vue';

export default{
  name: 'product-gallery-slot',

  components: {
    ProductGallery
  },

  props: {
    slotName: {
      type: String,
      required: true,
    },
    withCategory: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    gallery() {
      return this.$store.state.productGalleries.slots[this.slotName] || {};
    },
    TITLE() {
      return this.gallery.title;
    },
    PRODUCTS() {
      return this.gallery.products || [];
    },
    hasGallery() {
      return !!this.PRODUCTS.length;
    },
  },

  methods: {
    ...mapActions('productGalleries', ['loadSlot'])
  },

  serverPrefetch () {
    return this.loadSlot({ slot: this.slotName, withCategory: this.withCategory });
  },
}
</script>